<template>
  <v-dialog
    v-model="visibility"
    max-width="500"
    persistent
  >
    <v-card class="pa-0">
      <v-card-title class="headline pl-4 py-2 pr-2">
        Edytuj dostęp do katalogów
        <v-spacer></v-spacer>
        <v-btn
          @click.native="visibility = false"
          icon>
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="px-4">
        Czy na pewno chcesz wprowadzić zaznaczone zmiany?
      </v-card-text>

      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>

        <v-btn
          color="primary lighten-2"
          flat="flat"
          @click="setVisbility"
        >
          Anuluj
        </v-btn>

        <v-btn
          color="primary"
          :loading="busy"
          :disabled="busy"
          @click="storeAccesses"
        >
          Zapisz
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { storeAccessManage } from '../../../repository/users';

export default {
  name: 'users-access-dialog',
  data: () => ({
    busy: false,
  }),
  computed: {
    ...mapGetters('users', [
      'dialogVisibility',
      'dirAccess',
    ]),
    userId() {
      return this.dialogVisibility.userId;
    },
    visibility: {
      get() {
        return this.dialogVisibility.type === 'access';
      },
      set(val) {
        this.setDialogVisbility(val);
      },
    },
  },
  methods: {
    ...mapActions('users', [
      'setDialogVisbility',
    ]),
    setVisbility() {
      this.setDialogVisbility(false);
    },
    async storeAccesses() {
      this.busy = true;
      const data = {
        items_id: this.dirAccess,
      };
      try {
        await storeAccessManage(this.userId, data);
        this.setDialogVisbility(false);
        this.$emit('refresh-list');
        this.busy = false;
      } catch (e) {
        this.busy = false;
      }
    },
  },
};
</script>
